import { Component, Input } from '@angular/core';
import { ValidatorFn, Validators } from '@angular/forms';
import {
	DropdownControlComponent,
	DropdownOption,
} from '../../../controls/standard/dropdown-control/dropdown-control.component';
import { BaseFieldComponent } from '../base-field/base-field.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';

@Component({
	selector: 'app-dropdown-field',
	standalone: true,
	imports: [AppModule, ZorroModule, ThirdPartyModule, AngularModule, DropdownControlComponent],
	templateUrl: './dropdown-field.component.html',
	styleUrls: ['./dropdown-field.component.scss'],
})
export class DropdownFieldComponent extends BaseFieldComponent {
	@Input('options') public options: DropdownOption[] = [];
	@Input('multiple') public multiple: boolean = false;

	/**
	 * All validators required for this field.
	 * @date 7/15/2022 - 4:30:09 PM
	 *
	 * @public
	 * @static
	 * @override
	 * @type {ValidatorFn[]}
	 */
	public static override validators: ValidatorFn[] = [Validators.required];
}
